import { render } from "./AllWorkouts.vue?vue&type=template&id=498920a0"
import script from "./AllWorkouts.vue?vue&type=script&lang=js"
export * from "./AllWorkouts.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__